export default {
  DEFAULT: 'warning',
  SUCCESS: 'success',
  ERROR: 'critical',
  INFO: 'info',
};
